import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const Veterinary = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my veterinary business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps veterinary businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for veterinary businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most veterinary businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my veterinary business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like veterinary. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Veterinary - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Veterinary CRM", url: "/industries/veterinary" }
  ];

  const industryData = {
    name: 'Veterinary Clinic',
    title: 'Stop Missing Emergency Pet Calls & Fill Your Appointment Book Faster',
    subtitle: 'Capture emergency calls 24/7, send appointment reminders, and turn one-time visits into lifelong clients',
    icon: '🐾',
    challenges: [
      'Missing emergency calls after hours',
      'No-shows costing you revenue',
      'Difficult to follow up on treatment plans',
      'Lost revenue from missed vaccine reminders',
      'Time wasted on appointment scheduling'
    ],
    solutions: [
      '24/7 emergency call capture with instant SMS alerts',
      'Automated appointment reminders reduce no-shows by 40%',
      'Follow-up sequences for treatment compliance',
      'Automatic vaccine and checkup reminders',
      'Online booking for routine appointments'
    ],
    features: [
      'Pet owner CRM with pet profiles',
      'Automated appointment reminders (SMS & email)',
      'Emergency call routing 24/7',
      'Treatment follow-up automation',
      'Vaccine & wellness reminders',
      'Online booking calendar',
      'Review automation for happy pet owners',
      'Mobile app for on-the-go access'
    ],
    results: [
      '40% reduction in no-shows',
      '60% more emergency calls captured',
      '3x more vaccine appointment bookings',
      '£3.2K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Veterinary UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for veterinary businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for veterinary UK, veterinary business software, veterinary customer management, veterinary lead generation UK"
        url="/industries/veterinary"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default Veterinary;